"use client";

import React from "react";
import { useConsent } from "./ConsentProvider";
import { useLabels } from "@/lib/labels/LabelsProvider";

export function CookieSettingsLink({ className }: { className?: string }) {
    const { openPreferences } = useConsent();
    const labels = useLabels();

    return (
        <button
            type="button"
            onClick={openPreferences}
            className={className || "text-sm underline hover:opacity-80 transition"}
        >
            {labels.consent.footerLink}
        </button>
    );
}
